import { jsx as _jsx } from "react/jsx-runtime";
import MobilePopoverContent from '@/Components/Popover/MobilePopoverContent';
import { useAndroidBackHandler } from '@/NativeMobileWeb/useAndroidBackHandler';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { c } from 'ttag';
import EnhancedSearchOptionsContent from './EnhancedSearchOptionsContent';
const SearchFilterSheet = ({ open, onClose, searchOptions }) => {
    const addAndroidBackHandler = useAndroidBackHandler();
    useEffect(() => {
        if (!open) {
            return;
        }
        return addAndroidBackHandler(() => {
            onClose();
            return true;
        });
    }, [addAndroidBackHandler, onClose, open]);
    return (_jsx(MobilePopoverContent, { open: open, requestClose: onClose, title: c('B3.Notes.NoteList.Title').t `Search filters`, id: "search-filters", className: "p-4", children: _jsx(EnhancedSearchOptionsContent, { searchOptions: searchOptions }) }));
};
export default observer(SearchFilterSheet);
